export const viewTitle = "Паспорт архива";
export const viewUniqKey = "passportArchiveReport";
